import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "Store/configureStore";

export const selectEnvVariableState = (state: RootState) =>
  state.environmentVariable ?? {};

export const selectEnvVariables = createSelector(
  selectEnvVariableState,
  (
    _: RootState,
    params: { organizationId: string; projectId: string; environmentId: string }
  ) => params,
  (envVariableState, { organizationId, projectId, environmentId }) =>
    envVariableState.data?.[organizationId]?.[projectId]?.[environmentId] ?? {}
);

export const selectEnvVariablesArray = createSelector(
  selectEnvVariables,
  envVariables => Object.values(envVariables)
);

export const selectEnvVariable = createSelector(
  selectEnvVariablesArray,
  (_: RootState, params: { variableId: string }) => params,
  (envVariables, { variableId }) =>
    envVariables.find(variable => variable.id === variableId)
);
